export const OauthRedirectUris_MaxValue = 20;

export const Env = {
    NotDeployed: "not_deployed",
    InDeployment: "in_deployment",
    Deployed: "deployed"
};

export const State = {
    New: "new",
    Active: "active",
    Stopped: "stopped",
    Blocked: "blocked",
    Deleted: "deleted"
};

export const ModelType = {
    Internal: "internal",
    Business: "business",
    PayAsYouGo: "payasyougo",
    RainbowStore: "rainbowstore",
    Demo: "demo"
};

export const PushNotificationType = {
    Fcm: "fcm",
    FcmXmpp: "fcm_xmpp",
    Apns: "apns",
    ApnsV2: "apns_v2"
};

export const IosCertificateType = {
    Im: "im",
    Voip: "voip"
};

export const Type = {
    Admin: "admin",
    Bot: "bot",
    Desktop: "desktop",
    Iot: "iot",
    Mobile: "mobile",
    Server: "server",
    Web: "web"
}

export const Activity = {
    A: "A",
    B: "B",
    C: "C",
    D: "D",
    E: "E",
    F: "F",
    G: "G",
    H: "H",
    I: "I",
    J: "J",
    K: "K",
    L: "L",
    M: "M",
    N: "N",
    O: "O",
    P: "P",
    Q: "Q",
    R: "R",
    S: "S",
    T: "T",
    U: "U"
};
